var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "page" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  ref: "",
                  attrs: {
                    multiple: "",
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("pleaseSelectGame")
                  },
                  on: { change: _vm.gamechangeManageN },
                  model: {
                    value: _vm.searchData.game,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "game", $$v)
                    },
                    expression: "searchData.game"
                  }
                },
                _vm._l(_vm.searchgames, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.game_name, value: item.game_mark }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("pleaseSelectPlatform")
                  },
                  on: { change: _vm.platformchangeManage },
                  model: {
                    value: _vm.searchData.platform,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "platform", $$v)
                    },
                    expression: "searchData.platform"
                  }
                },
                _vm._l(_vm.searchplatforms, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: item.platform_name,
                      value: item.platform_mark
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("pleaseSelectChannel")
                  },
                  on: { change: _vm.channelchangeManage },
                  model: {
                    value: _vm.searchData.channel,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "channel", $$v)
                    },
                    expression: "searchData.channel"
                  }
                },
                _vm._l(_vm.searchchannels, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: item.channel_name,
                      value: item.channel_mark
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("pleaseSelectDeliveryPackage")
                  },
                  model: {
                    value: _vm.searchData.pkg,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "pkg", $$v)
                    },
                    expression: "searchData.pkg"
                  }
                },
                _vm._l(_vm.searchpkgs, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.pkg_name, value: item.pkg_mark }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.searchClick(1)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addproductMapping.init()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("add")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "sticky-table-header",
              rawName: "v-sticky-table-header",
              value: 0,
              expression: "0"
            },
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          ref: "tableRef",
          attrs: { id: "tableRef", data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "id",
              label: _vm.$t("idLabel"),
              "show-overflow-tooltip": "",
              width: "60"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "channel", label: _vm.$t("icon") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("img", {
                      staticStyle: { width: "100px", height: "100px" },
                      attrs: {
                        src: row.icon.includes("https")
                          ? row.icon
                          : _vm.$utils.imgTrow(row.icon),
                        alt: ""
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "appid",
              label: _vm.$t("appId"),
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", {}, [
                      _vm._v(" " + _vm._s(row.appid || "/") + " ")
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "name",
              label: _vm.$t("productNameLabel"),
              "show-overflow-tooltip": ""
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "game_reveal",
              label: _vm.$t("game"),
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "cur",
                        attrs: { effect: "dark", placement: "top" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "cur",
                            attrs: { slot: "content" },
                            on: {
                              click: function($event) {
                                return _vm.$utils.capy(row.game)
                              }
                            },
                            slot: "content"
                          },
                          [_vm._v(_vm._s(row.game))]
                        ),
                        _c("div", [
                          _vm._v(" " + _vm._s(row.game_reveal || "/") + " ")
                        ])
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "platform_reveal",
              label: _vm.$t("platform"),
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "cur",
                        attrs: { effect: "dark", placement: "top" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "cur",
                            attrs: { slot: "content" },
                            on: {
                              click: function($event) {
                                return _vm.$utils.capy(row.platform)
                              }
                            },
                            slot: "content"
                          },
                          [_vm._v(_vm._s(row.platform))]
                        ),
                        _c("div", [
                          _vm._v(" " + _vm._s(row.platform_reveal || "/") + " ")
                        ])
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "channel_reveal",
              label: _vm.$t("channel"),
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "cur",
                        attrs: { effect: "dark", placement: "top" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "cur",
                            attrs: { slot: "content" },
                            on: {
                              click: function($event) {
                                return _vm.$utils.capy(row.channel)
                              }
                            },
                            slot: "content"
                          },
                          [_vm._v(_vm._s(row.channel))]
                        ),
                        _c("div", [
                          _vm._v(" " + _vm._s(row.channel_reveal || "/") + " ")
                        ])
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "pkg_reveal",
              label: _vm.$t("pkg"),
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "cur",
                        attrs: { effect: "dark", placement: "top" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "cur",
                            attrs: { slot: "content" },
                            on: {
                              click: function($event) {
                                return _vm.$utils.capy(row.pkg)
                              }
                            },
                            slot: "content"
                          },
                          [_vm._v(_vm._s(row.pkg))]
                        ),
                        _c("div", [
                          _vm._v(" " + _vm._s(row.pkg_reveal || "/") + " ")
                        ])
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("operation"),
              width: "160",
              align: "center",
              fixed: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.$refs.addproductMapping.init(row)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("modify")))]
                      ),
                      _c("div", { staticClass: "controlsBtn-vertical" }),
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.handleDelete(row.id)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("delete")))]
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("addproductMapping", {
        ref: "addproductMapping",
        on: {
          change: function($event) {
            return _vm.searchClick(_vm.searchData.page)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }